<template>
    <footer class="dark-footer dark-footer-mini skin-dark-footer">
        <div class="f-footer-menu">
            <a href="https://www.callalawyer.fr/legal/politique-de-confidentialite" target="_blank"
                class="f-footer-link-legal w-inline-block">
                <div>Politique de confidentialité</div>
            </a>
            <div class="f-footer-vertical-divider"></div><a
                href="https://www.callalawyer.fr/legal/informations-utilisateurs" target="_blank"
                class="f-footer-link-legal w-inline-block">
                <div class="text-block-62">CGU&nbsp;</div>
            </a>
        </div>
    </footer>
</template>

<script setup>
import { ref } from 'vue';
const year = ref(new Date().getFullYear());
</script>

<style lang="scss" scoped>
.dark-footer-mini {
    background-color: #fff;
    border-top: 1px dashed #d5dee6;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 5%;
    padding-right: 5%;
    display: flex;
    position: fixed;
    bottom: 0;

    & .f-footer-menu {
        grid-column-gap: 10px;
        grid-row-gap: 10px;
        flex: 1;
        align-items: flex-end;
        max-width: 1400px;
        margin-top: 0;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        overflow: auto;

        & .f-footer-link-legal {
            max-width: 100%;
            display: inline-block;
            color: #303030;
            text-align: center;
            letter-spacing: -.01em;
            text-transform: capitalize;
            flex: 0 auto;
            width: 100%;
            margin-top: .25rem;
            margin-bottom: .25rem;
            padding-top: 4px;
            padding-bottom: 4px;
            font-family: Lato, sans-serif;
            font-size: 12px;
            font-weight: 700;
            line-height: 24px;
            text-decoration: none;
            transition: color .3s;
        }
    }
}
</style>
